// extracted by mini-css-extract-plugin
module.exports = {"social":"SocialLinks_social__v3BMt","socialLink":"SocialLinks_socialLink__DsSO5"};